<template>
    <div class="button-group">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        name: 'ButtonGroup',
        components: {
        },
        props: [],
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./ButtonGroup.scss" lang="scss"></style>
